import React, { useState } from "react";
import eyeIcon from "../assets/eye.svg";
import eyeSlashIcon from "../assets/eye-slash.svg";

/**
 * Password input with show/hide toggle button.
 * Handles browser autofill (Chrome "Use strong password") gracefully
 * by capturing both onChange and onInput events.
 */
export default function PasswordInput({ onChange, className, ...props }) {
  const [visible, setVisible] = useState(false);

  const handleInput = (e) => {
    // Backup for browser autofill that doesn't trigger onChange
    if (onChange && e.target.value !== props.value) {
      onChange(e);
    }
  };

  return (
    <div className="pwInputWrap">
      <input
        {...props}
        type={visible ? "text" : "password"}
        className={`gwInput pwInput ${className || ""}`}
        onChange={onChange}
        onInput={handleInput}
      />
      <button
        type="button"
        className="pwToggle"
        onMouseDown={(e) => {
          e.preventDefault();
          setVisible((v) => !v);
        }}
        aria-label={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
      >
        <img
          src={visible ? eyeSlashIcon : eyeIcon}
          alt=""
          className="pwToggleIcon"
        />
      </button>
    </div>
  );
}
